import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})

class PermissionsService {
  constructor(private router: Router, private authService: AuthService) {}
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // console.log('in main auth guard: ' + isLoggedIn);
    return this.authService.isAuthenticated();
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean  {
    const isLoggedIn = this.authService.isAuthenticated();
    // console.log('in child auth guard: ' + isLoggedIn);
    if (isLoggedIn) {
      return true;
    } else {
      this.router.navigateByUrl('/login').then(r => {});
      return false;
    }
  }
}
export const AuthGuard: CanActivateChildFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(PermissionsService).canActivateChild(next, state);
};
